import { render } from "./ConsultarModificacion.vue?vue&type=template&id=0c93a454"
import script from "./ConsultarModificacion.vue?vue&type=script&lang=js"
export * from "./ConsultarModificacion.vue?vue&type=script&lang=js"

import "./ConsultarModificacion.vue?vue&type=style&index=0&id=0c93a454&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__